import { useState, useEffect, useContext } from "react";
import { fetchUsers, fetchReferralUserCount } from "../services/apis";
import { useAuth } from "../context/authContext";
import { DEMO_DATA } from "../utils/demoData";

const useUsers = (initialFilter) => {
  const [users, setUsers] = useState(0);
  const [employees, setEmployees] = useState(0);
  const { code } = useAuth();
  const [filter, setFilter] = useState(initialFilter);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // const code = localStorage.getItem("code");

   const demo = DEMO_DATA[code];

  useEffect(() => {
     if (demo) return; 
    const getUserCount = async () => {
      try {
        setLoading(true);
        const response = await fetchUsers(code);
        const response2 = await fetchReferralUserCount(code);
        setUsers(response.data);
        // fetchReferralUserCount resolves to { referalCode, userCount },
        // not { data }, so pull userCount off it directly.
        setEmployees(response2?.userCount ?? 0);
        setError(null);
      } catch (err) {
        setError(err.message || "An error occurred while fetching user data.");
      } finally {
        setLoading(false);
      }
    };

    getUserCount();
  }, [code, filter]);

   if (demo) {
    return {
      users: demo.users,
      employees: demo.employees,
      filter,
      setFilter,
      loading: false,
      error: null,
    };
  }

  return { users, filter, setFilter, loading, error, employees };
};

export default useUsers;